/* eslint-disable camelcase */
import axios from 'src/api/Api';
import {
    GET_CALENDAR_SETTINGS_SUCCESS,
    GET_CALENDAR_SETTINGS_FAILURE,
    UPDATED_CALENDAR_SHARE_LINK_SUCCESS,
    UPDATED_CALENDAR_SHARE_LINK_FAILURE,
    IS_SETTING_PAGE_UPDATE,
    IS_GENERATED_LINK_UPDATE,
    UPDATE_TURN_ON_GENERATED_LINK,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getCalendarSettings(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/userpreferences?`;
    const resourceType = 'CALENDAR_SETTINGS';
    const params = convertObjectToQueryParams({
        resource_type: resourceType,
    });
    let finalUrl = url + `${params}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);
        //console.log('resulats',result);

        if (action?.payload && !action?.payload?.isUpdateLink) {
            yield put({
                type: IS_SETTING_PAGE_UPDATE,
                payload: { isSettingPageUpdate: false },
            });

            const updateCalendarSetting = { ...(result['calendarSettings'] || {}) };
            updateCalendarSetting.calendarSharingAddress =
                updateCalendarSetting?.calendarSharingAddress || '';
            updateCalendarSetting.calendarSharingAddressGeneratedDate =
                updateCalendarSetting?.calendarSharingAddressGeneratedDate || '';
            updateCalendarSetting.isCalendarSharing =
                updateCalendarSetting?.isCalendarSharing ?? false;
            updateCalendarSetting.defaultView =
                updateCalendarSetting?.defaultView || 'month';
            result['calendarSettings'] = updateCalendarSetting;

            const sanitizedNotificationSettings = result['notificationSettings'] || {};
            result['notificationSettings'] = {
                ...sanitizedNotificationSettings,
                mobilePhoneNumber: sanitizedNotificationSettings?.mobilePhoneNumber || '',
                currentEmailAddress: sanitizedNotificationSettings?.currentEmailAddress || '',
                alternateEmailAddress: sanitizedNotificationSettings?.alternateEmailAddress || '',
            };

            yield put({ type: GET_CALENDAR_SETTINGS_SUCCESS, payload: result });
        } else {
            //console.log('resultasdf',result);
            yield put({
                type: UPDATE_TURN_ON_GENERATED_LINK,
                payload: {
                    calendarSharingAddress: result.calendarSettings
                        ?.calendarSharingAddress
                        ? result.calendarSettings.calendarSharingAddress
                        : '',
                    calendarSharingAddressGeneratedDate: result.calendarSettings
                        ?.calendarSharingAddressGeneratedDate
                        ? result.calendarSettings
                              .calendarSharingAddressGeneratedDate
                        : '',
                    isCalendarSharing:
                        result.calendarSettings.isCalendarSharing,
                    defaultView: result.calendarSettings.defaultView,
                },
            });
            yield put({
                type: IS_GENERATED_LINK_UPDATE,
                payload: { isGeneratedLinkUpdate: false, loading: false },
            });
        }
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: finalUrl,
            requestPayload: action?.payload || {}
        });
        yield put({
            type: GET_CALENDAR_SETTINGS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}

export function* getNewCalendarLink() {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/userpreferences?`;
    const resourceType = 'SHARE_LINK';
    const params = convertObjectToQueryParams({
        resource_type: resourceType,
    });
    let finalUrl = url + `${params}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);
        yield put({
            type: UPDATED_CALENDAR_SHARE_LINK_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: finalUrl,
            requestPayload: {}
        });
        yield put({
            type: UPDATED_CALENDAR_SHARE_LINK_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
